import { IColor } from './../utils/types/colors';
import { axios, Store } from "@utils";
import { action, computed, makeObservable, runInAction } from "mobx";
import { Service } from "typedi";
import { innerCalendarColor } from './storeConstants';

@Service()
export class CalendarColorsStore extends Store<IColor> {

  constructor() {
    super();
    makeObservable(this);
  }

  @action getColors = () => {
    this.isLoading = true;
    axios
      .get('picklist/calendar-colors')
      .then((resp) => runInAction(() => {
        this.data = resp.data;
        this.data.push(innerCalendarColor)
        this.isLoading = false;
      }));
  };

  @computed get colorsWithoutInnerColor() {
    return this.data.filter((elem) => elem !== innerCalendarColor);
  }

  getColorByName = (colorName: string) => this.data.find((color) => color.colorName === colorName);
}
